module.exports = __webpack_public_path__ + "img/ring_y_l_null_null@3x.3abf660a.png";